import { ClockCounterClockwise, Flag } from "@phosphor-icons/react"
import { createFileRoute, Outlet } from "@tanstack/react-router"

import { Module } from "~/components/design-system/pages"
import { EnvironmentBadge, FlagPanelProvider } from "~/features/feature-flags/pages"
import { BreadcrumbWrapper } from "~/components/reusable/Breadcrumb"
import { type HeaderTab } from "~/components/reusable/HeaderTabs"
export const Route = createFileRoute("/_auth/internal/feature-flags/_overview")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

const tabs: HeaderTab[] = [
  { label: "Flags", path: "/internal/feature-flags", icon: <Flag /> },
  { label: "History", path: "/internal/feature-flags/history", icon: <ClockCounterClockwise /> },
]

function RouteComponent() {
  return (
    <Module
      breadcrumb={<BreadcrumbWrapper />}
      actions={<EnvironmentBadge />}
      tabs={{ items: tabs, path: "/internal/feature-flags" }}
    >
      <FlagPanelProvider>
        <Outlet />
      </FlagPanelProvider>
    </Module>
  )
}
